import * as Types from '../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IvrActionReferencesFragment = { __typename?: 'References', ivrActions: Array<{ __typename?: 'IvrAction', id: number, button: number, ivrProfile?: { __typename?: 'IvrProfile', name: string, ivr?: { __typename?: 'Ivr', id: number, name: string, numberId: number } | null, mainParent?: { __typename?: 'IvrProfile', ivr?: { __typename?: 'Ivr', id: number, name: string, numberId: number } | null } | null } | null, targetNumber1?: { __typename?: 'Number', shortNumber?: string | null } | null }> };

export type PhoneButtonReferencesFragment = { __typename?: 'References', phoneButtons: Array<{ __typename?: 'BasePhoneButton', id: number, speedDialNumber?: string | null, buttonPosition: number, device?: { __typename?: 'Device', id: number, extensionId: number, extension?: { __typename?: 'User', displayName: string, numberId: number, number?: { __typename?: 'Number', shortNumber?: string | null } | null } | null } | null }> };

export type GatewayReferencesFragment = { __typename?: 'References', gateways: Array<{ __typename?: 'Gateway', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null }> };

export type SecretaryReferencesFragment = { __typename?: 'References', secretary: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null }> };

export type OverrideCallerReferencesFragment = { __typename?: 'References', overrideCaller: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null }> };

export type RelatedDataQueryVariables = Types.Exact<{
  targetId: Types.Scalars['Int']['input'];
  numberType: Types.NumberType;
}>;


export type RelatedDataQuery = { __typename?: 'Query', relatedData: { __typename?: 'References', phoneButtons: Array<{ __typename?: 'BasePhoneButton', id: number, speedDialNumber?: string | null, buttonPosition: number, device?: { __typename?: 'Device', id: number, extensionId: number, extension?: { __typename?: 'User', displayName: string, numberId: number, number?: { __typename?: 'Number', shortNumber?: string | null } | null } | null } | null }>, ivrActions: Array<{ __typename?: 'IvrAction', id: number, button: number, ivrProfile?: { __typename?: 'IvrProfile', name: string, ivr?: { __typename?: 'Ivr', id: number, name: string, numberId: number } | null, mainParent?: { __typename?: 'IvrProfile', ivr?: { __typename?: 'Ivr', id: number, name: string, numberId: number } | null } | null } | null, targetNumber1?: { __typename?: 'Number', shortNumber?: string | null } | null }>, gateways: Array<{ __typename?: 'Gateway', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null }>, secretary: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null }>, overrideCaller: Array<{ __typename?: 'User', id: number, displayName: string, number?: { __typename?: 'Number', id: number, shortNumber?: string | null } | null }> } };

export const IvrActionReferencesFragmentDoc = gql`
    fragment IvrActionReferences on References {
  ivrActions {
    id
    button
    ivrProfile {
      name
      ivr {
        id
        name
        numberId
      }
      mainParent {
        ivr {
          id
          name
          numberId
        }
      }
    }
    targetNumber1 {
      shortNumber
    }
  }
}
    `;
export const PhoneButtonReferencesFragmentDoc = gql`
    fragment PhoneButtonReferences on References {
  phoneButtons {
    id
    speedDialNumber
    buttonPosition
    device {
      id
      extensionId
      extension {
        displayName
        numberId
        number {
          shortNumber
        }
      }
    }
  }
}
    `;
export const GatewayReferencesFragmentDoc = gql`
    fragment GatewayReferences on References {
  gateways {
    id
    displayName
    number {
      id
      shortNumber
    }
  }
}
    `;
export const SecretaryReferencesFragmentDoc = gql`
    fragment SecretaryReferences on References {
  secretary {
    id
    displayName
    number {
      id
      shortNumber
    }
  }
}
    `;
export const OverrideCallerReferencesFragmentDoc = gql`
    fragment OverrideCallerReferences on References {
  overrideCaller {
    id
    displayName
    number {
      id
      shortNumber
    }
  }
}
    `;
export const RelatedDataDocument = gql`
    query RelatedData($targetId: Int!, $numberType: NumberType!) {
  relatedData(id: $targetId, numberType: $numberType) {
    ...PhoneButtonReferences
    ...IvrActionReferences
    ...GatewayReferences
    ...SecretaryReferences
    ...OverrideCallerReferences
  }
}
    ${PhoneButtonReferencesFragmentDoc}
${IvrActionReferencesFragmentDoc}
${GatewayReferencesFragmentDoc}
${SecretaryReferencesFragmentDoc}
${OverrideCallerReferencesFragmentDoc}`;

/**
 * __useRelatedDataQuery__
 *
 * To run a query within a React component, call `useRelatedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedDataQuery({
 *   variables: {
 *      targetId: // value for 'targetId'
 *      numberType: // value for 'numberType'
 *   },
 * });
 */
export function useRelatedDataQuery(baseOptions: Apollo.QueryHookOptions<RelatedDataQuery, RelatedDataQueryVariables> & ({ variables: RelatedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedDataQuery, RelatedDataQueryVariables>(RelatedDataDocument, options);
      }
export function useRelatedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedDataQuery, RelatedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedDataQuery, RelatedDataQueryVariables>(RelatedDataDocument, options);
        }
export function useRelatedDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedDataQuery, RelatedDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatedDataQuery, RelatedDataQueryVariables>(RelatedDataDocument, options);
        }
export type RelatedDataQueryHookResult = ReturnType<typeof useRelatedDataQuery>;
export type RelatedDataLazyQueryHookResult = ReturnType<typeof useRelatedDataLazyQuery>;
export type RelatedDataSuspenseQueryHookResult = ReturnType<typeof useRelatedDataSuspenseQuery>;
export type RelatedDataQueryResult = Apollo.QueryResult<RelatedDataQuery, RelatedDataQueryVariables>;